import React, { useEffect, useState } from 'react'
import { useHistory, Route, Switch } from 'react-router-dom'
import { getQueryParameters } from 'src/helpers/tool'
import { PATH_URL } from 'src/helpers/path'
import { useAppContext } from 'src/helpers/app'
import { preserveUrlParams } from 'src/helpers/preserveUrlParams'
import ColorPalette from './ColorPalette'
import styles from './styles.module.scss'
import FlowerSelectionPage from './FlowerSelectionPage'
import EssentialsCollectionPage from './EssentialsCollectionPage'
import PartnerFullName from './PartnerFullName'
import DatePickerPage from './DatePickerPage'
import EmailEntryPage from './EmailEntryPage'
import ResultCalculationPage from './ResultCalculationPage'
import GuestCountPage from './GuestCountPage'
import ExpectedBudgetPage from './ExpectedBudgetPage'
import PartyCountPage from './PartyCountPage'
import TableCountPage from './TableCountPage'
import FloralPlanningPage from './FloralPlanningPage'
import CollectionsProgressBar from './CollectionsProgressBar'

const CollectionsQuizEntry: React.FC = () => {
  const history = useHistory()
  const { sessionID } = useAppContext()
  const [isNavigating, setIsNavigating] = useState(false)

  useEffect(() => {
    // Check for tier2 parameter
    const params = getQueryParameters()
    const isTier2Flow = params.get('tier2') === 'true'
    const collectionId = params.get('collectionId')

    if (isTier2Flow) {
      console.log('Tier 2 flow detected')
      // Will implement specific flow later
    }

    // Check for collectionId parameter - skip ColorPalette and FlowerSelectionPage
    if (collectionId) {
      console.log('Collection ID detected:', collectionId)
      // Save collectionId and sessionID to localStorage for later use
      const collectionsQuizEntry = JSON.parse(localStorage.getItem('collectionsQuizEntry') || '{}')
      collectionsQuizEntry.collectionId = collectionId
      if (sessionID) {
        collectionsQuizEntry.sessionID = sessionID
      }
      const collectionIdNumber = !isNaN(Number(collectionId)) ? Number(collectionId) : collectionId
      if (
        !collectionsQuizEntry.selectedCollection ||
        collectionsQuizEntry.selectedCollection.id !== collectionIdNumber
      ) {
        collectionsQuizEntry.selectedCollection = { id: collectionIdNumber }
      }
      localStorage.setItem('collectionsQuizEntry', JSON.stringify(collectionsQuizEntry))

      // If we're on ColorPalette or FlowerSelectionPage, redirect to EmailEntryPage
      const currentPath = history.location.pathname
      if (
        currentPath === PATH_URL.COLLECTIONS_QUIZ_COLOR_PALETTE ||
        currentPath === PATH_URL.COLLECTIONS_QUIZ_FLOWER_SELECTION
      ) {
        const nextUrl = preserveUrlParams(PATH_URL.COLLECTIONS_QUIZ_EMAIL_ENTRY)
        history.replace(nextUrl)
      }
    }

    // Listen for navigation changes
    const unlisten = history.listen(() => {
      setIsNavigating(true)

      // Scroll to top on navigation for mobile devices
      if (window.innerWidth <= 768) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }

      // Reset navigation state after a short delay
      setTimeout(() => {
        setIsNavigating(false)
      }, 100)
    })

    return () => {
      unlisten()
      setIsNavigating(false)
    }
  }, [history, sessionID])

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.layout}>
        <CollectionsProgressBar />
        <main className={styles.container}>
          <Switch>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_COLOR_PALETTE}>
              <ColorPalette key={isNavigating ? 'navigating' : 'static'} />
            </Route>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_FLOWER_SELECTION}>
              <FlowerSelectionPage key={isNavigating ? 'navigating' : 'static'} />
            </Route>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_ESSENTIALS}>
              <EssentialsCollectionPage key={isNavigating ? 'navigating' : 'static'} />
            </Route>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_PARTNER_FULL_NAME}>
              <PartnerFullName key={isNavigating ? 'navigating' : 'static'} />
            </Route>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_DATE_PICKER}>
              <DatePickerPage key={isNavigating ? 'navigating' : 'static'} />
            </Route>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_EMAIL_ENTRY}>
              <EmailEntryPage key={isNavigating ? 'navigating' : 'static'} />
            </Route>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_RESULT_CALCULATION}>
              <ResultCalculationPage key={isNavigating ? 'navigating' : 'static'} />
            </Route>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_GUEST_COUNT}>
              <GuestCountPage key={isNavigating ? 'navigating' : 'static'} />
            </Route>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_EXPECTED_BUDGET}>
              <ExpectedBudgetPage key={isNavigating ? 'navigating' : 'static'} />
            </Route>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_PARTY_COUNT}>
              <PartyCountPage key={isNavigating ? 'navigating' : 'static'} />
            </Route>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_TABLE_COUNT}>
              <TableCountPage key={isNavigating ? 'navigating' : 'static'} />
            </Route>
            <Route path={PATH_URL.COLLECTIONS_QUIZ_FLORAL_PLANNING}>
              <FloralPlanningPage key={isNavigating ? 'navigating' : 'static'} />
            </Route>
          </Switch>
        </main>
      </div>
    </div>
  )
}

export default CollectionsQuizEntry
